import { Configuration } from './configuration';

// Reads CRA env (available at build time). Example: http://localhost:5000/api
const RAW = process.env.REACT_APP_API_BASE_URL || '';

// Trim trailing slashes
const TRIMMED = RAW.replace(/\/+$/, '');

// If generated paths already start with "/api/...", drop trailing "/api" from base
const basePath = TRIMMED.endsWith('/api') ? TRIMMED.slice(0, -4) : TRIMMED;

export const apiConfiguration = new Configuration({
  basePath: basePath || 'http://localhost:5000',
});

export function getResolvedBasePath() {
  return (basePath || 'http://localhost:5000');
}
